<template>
    <div>
        <el-row :gutter="30">
            <el-col :xs="24" :xl="16">
                <el-card shadow="never" class="MT20">
                    <el-row :gutter="30">
                        <el-col><span class="color-info">用户ID: </span>{{formData.userId}}</el-col>
                        <el-col><span class="color-info">用户名称: </span>{{formData.name}}</el-col>
                        <el-col><span class="color-info">用户类型: </span>{{$userType.get(formData.userType)}}</el-col>
						<el-col><span class="color-info">创建来源: </span>{{formData.source}}</el-col>
                    </el-row>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="30" class="MT20">
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="contractSn" label="合同编号:" :rules="[{required: true, message: '请输入合同编号'}]">
                    <el-input
                        v-model.trim="formData.contractSn"
                        placeholder="请输入合同编号"
                        size="medium"
                        maxlength="100"
                    ></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="contractExpireTime" label="合同到期时间:" :rules="[{required: true, message: '请输入合同到期时间'}]">
                    <el-date-picker
                        v-model="formData.contractExpireTime"
                        type="datetime"
                        start-placeholder="合同到期时间"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        size="medium">
                    </el-date-picker>
                </el-form-item>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    props:{
        formData:{
            type: Object,
            default: null
        }
    },
    data(){
        return{}
    }
}
</script>